module.exports = __webpack_public_path__ + "8d17031ff4bd1cae79d8bbbe68d96578.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/iconfont.ttf
 ** module id = 228
 ** module chunks = 0
 **/